import { MapTo } from '@adobe/aem-react-editable-components';
import Article, { ArticleEditConfig } from './Article';

export default MapTo('cob-corp-acquisition/components/creditonebank/article')(Article, ArticleEditConfig);